import { DonorRoleEnum, UserCategoryEnum, UserRole } from "./ModelEnums";

export type SubMenu = {
  menuTitle: string;
  menuLink?: string;
  icon: string;
};

export type MenuItem = {
  subMenus?: SubMenu[];
} & SubMenu;

export const filterMenu = (
  permissions: { Name: string; UserPermissionCd: string }[],
  userCategory: UserCategoryEnum,
  userRole: UserRole,
  userReference: string,
) => {
  //const permissionCode = permissions.map((item) => item.UserPermissionCd);
  let administration: MenuItem = {
    menuTitle: "Administration",
    icon: "fa-light fa-user-tie",
    subMenus: [],
  };
  let support: MenuItem = {
    menuTitle: "Support",
    icon: "fa-light fa-headset",
    subMenus: [],
  };
  let financial: MenuItem = {
    menuTitle: "Financial",
    icon: "fa-light fa-money-bill",
    subMenus: [],
  };

  // let committeeMemberOptions: MenuItem = {
  //   menuTitle: "Manage Committee Membership",
  //   icon: "fa-light fa-money-bill",
  //   subMenus: [],
  // };

  let myProfileOptions: MenuItem = {
    menuTitle: "My Profile",
    icon: "fa-light fa-user",
    subMenus: [],
  };

  let menuItems: MenuItem[] = [];
  for (let item of permissions) {
    switch (item.UserPermissionCd) {
      case "UP_MgSCn":
        // Manage System Configuration
        // menuItems.push({
        //   menuTitle: "System Configuration",
        //   menuLink: "#",
        //   icon: "fa-light fa-screwdriver-wrench",
        // });
        break;
      case "UP_AdLst":
        // Administer Administrator
        administration.subMenus?.push({
          menuTitle: "Manage Administrators",
          menuLink: "/administrator",
          icon: "fa-light fa-users",
        });

        // menuItems.push({
        //   menuTitle: "Support Queue",
        //   menuLink: "/supportqueue",
        //   icon: "fa-light fa-headset",
        // });
        break;

      case "UP_VwAdD":
        // View Administrator Dashboard

        break;
      case "UP_MgBSL":
        // Manage Business Sponsorship Levels
        // menuItems.push({
        //   menuTitle: "Busniess Sponsorship",
        //   menuLink: "#",
        //   icon: "fa-light fa-building",
        // });
        break;

      case "UP_FRLst":
        // Review Funding Requests
        if (userCategory === "UC_A")
          support.subMenus?.push({
            menuTitle: "Funding Requests",
            menuLink: "/fundingrequest",
            icon: "fa-light fa-hand-holding-hand",
          });
        else
          menuItems.push({
            menuTitle: "Funding Requests",
            menuLink: "/fundingrequest/list",
            icon: "fa-light fa-hand-holding-hand",
          });

        break;
      case "UP_SILst":
        support.subMenus?.push({
          menuTitle: "School Invitations",
          menuLink: "/schoolinvitation",
          icon: "fa-light fa-comments",
        });

        break;
      case "UP_ScLst":
        // Administer Schools
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Manage School",
            menuLink: "/school",
            icon: "fa-light fa-chalkboard-user",
          });

        break;
      case "UP_DoLst":
        // Administer Donors
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Manage Donors",
            menuLink: "/donor",
            icon: "fa-light fa-hand-holding-dollar",
          });

        break;
      case "UP_RecBT":
        if (userCategory === "UC_A")
          // Reconcile Bank Transactions
          financial.subMenus?.push({
            menuTitle: "Reconcile Transaction",
            menuLink: "reconciletransaction",
            icon: "fa-light fa-money-check",
          });

        break;

      case "UP_SELst":
        // System Events Review
        if (userCategory === "UC_A")
          support.subMenus?.push({
            menuTitle: "System Events Log",
            menuLink: "/systemevents",
            icon: "fa-light fa-gears",
          });

        break;

      // School Principal

      case "UP_ScBAR":
        // Request To Change Own School Bank Account

        menuItems.push({
          menuTitle: "Financial Details",
          menuLink: "/schoolofficer/mfafinancialdetails",
          icon: "fa-light fa-money-check-dollar",
        });
        break;
      case "UP_VOSDa":
        // View Own School Dashboard
        break;
      case "UP_EdOPD":
        // Edit Own Personal Details
        break;
      case "UP_VOSDo":
        // View School Donations

        menuItems.push({
          menuTitle: "School Donations",
          menuLink: "/donor/donorpayment",
          icon: "fa-light fa-hand-holding-dollar",
        });
        break;
      case "UP_SOLst":
        // Edit own school staff

        if (userCategory === "UC_S")
          menuItems.push({
            menuTitle: "School Officers",
            menuLink: "/schoolofficer",
            icon: "fa-light fa-graduation-cap",
          });
        break;
      case "UP_ScUSO":
        //Edit own school details

        if (userCategory === "UC_S")
          menuItems.push({
            menuTitle: "School Details",
            menuLink: "/schooldetails",
            icon: "fa-light fa-building",
          });
        break;
      case "UP_EOSFR":
        // Edit own school funding requests

        menuItems.push({
          menuTitle: "Funding Requests",
          menuLink: "/fundingrequest/list",
          icon: "fa-light fa-hand-holding-hand",
        });
        break;
      case "UP_VwOSR":
        // View Own School Reports

        menuItems.push({
          menuTitle: "School Report",
          menuLink: "/school/report",
          icon: "fa-light fa-chart-simple",
        });

        break;

      // Donors

      case "UP_DPLst":
        // View Own Donations

        // donor/donorpayment
        if (userCategory === "UC_D")
          menuItems.push({
            menuTitle: "Donor Payments",
            menuLink: `/donor/donorpayment?uref=${userReference}`,
            icon: "fa-light fa-hand-holding-dollar",
          });

        break;
      case "UP_DPTLt":
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Donor Transactions List",
            menuLink: "/donor/donorpayment/transactions",
            icon: "fa-light fa-files",
          });

        break;
      case "UP_AJLst":
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Account Journal List",
            menuLink: "/accountjournal",
            icon: "fa-light fa-files",
          });

        break;
      case "UP_AcLst":
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Account List",
            menuLink: "/account",
            icon: "fa-light fa-files",
          });

        break;
      case "UP_AdPLt":
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Administration Transactions List",
            menuLink: "/committeemember/transactions/",
            icon: "fa-light fa-files",
          });

        break;

      // case "UP_SOTLt":
      //   if (userCategory === "UC_A")
      //     administration.subMenus?.push({
      //       menuTitle: "SO Transactions List",
      //       menuLink: "/schoolofficer/transactions/",
      //       icon: "fa-light fa-files",
      //     });

      //   break;

      case "UP_DonAc":
        // Edit Own Donation Details
        if (userCategory === "UC_D")
          menuItems.push({
            menuTitle: "Donation Details",
            menuLink: "/donor/donationdetails/",
            icon: "fa-light fa-circle-info",
          });
        break;

      case "UP_CMUpd":
        if (userCategory == "UC_C")
          menuItems.push({
            menuTitle: "Membership Details",
            menuLink: "/committeemember",
            icon: "fa-light fa-user-plus",
          });

        break;

      case "UP_SOSPS":
        if (userCategory === "UC_S")
          myProfileOptions.subMenus?.push({
            menuTitle: "School Officer Membership Payments",
            menuLink: "/schoolofficerpayment",
            icon: "fa-light fa-user-plus",
          });
        break;

      case "UP_SJLst":
        if (userCategory === "UC_A")
          support.subMenus?.push({
            menuTitle: "Scheduled Jobs",
            menuLink: "/scheduledjobs",
            icon: "fa-light fa-clock-rotate-left",
          });
        break;
      case "UP_UPSel":
        if (userCategory === "UC_A")
          support.subMenus?.push({
            menuTitle: "User Permissions",
            menuLink: "/security/permissions",
            icon: "fa-light fa-shield-check",
          });
        break;
      case "UP_ASCre":
        if (userCategory === "UC_A")
          administration.subMenus?.push({
            menuTitle: "Manage ACARA Schools",
            menuLink: "/acara-school",
            icon: "fa-light fa-school",
          });
    }
  }
  if (userCategory !== "UC_C")
    myProfileOptions.subMenus?.push({
      menuTitle: "Edit Profile",
      menuLink: getLink(userCategory, userRole, userReference),
      icon: "fa-light fa-user-pen",
    });
  if (administration.subMenus?.length != 0) {
    administration.subMenus?.push({
      menuTitle: "Manage School Files",
      menuLink: "/schoolfile",
      icon: "fa-light fa-files",
    });

    menuItems.push(administration);
  }
  if (support.subMenus?.length != 0) menuItems.push(support);
  if (financial.subMenus?.length != 0) menuItems.push(financial);
  // if (committeeMemberOptions.subMenus?.length != 0)
  //   menuItems.push(committeeMemberOptions);

  if (userCategory === "UC_S")
    menuItems.push({
      menuTitle: "Files",

      icon: "fa-light fa-files",
      subMenus: [
        {
          menuTitle: "School Files",
          icon: "fa-light fa-files",
          menuLink: "/schoolfile",
        },
        {
          menuTitle: "Donation Transactions Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/donation-transactions",
        },
      ],
    });

  if (userCategory === "UC_A") {
    menuItems.push({
      menuTitle: "Reports",
      icon: "fa-light fa-file-chart-column",
      subMenus: [
        {
          menuTitle: "Donation Transactions Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/donation-transactions",
        },
        {
          menuTitle: "Participating Schools Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/participating-schools-report",
        },
        {
          menuTitle: "School Donors Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-donors-report",
        },
        {
          menuTitle: "School Funding Request Detail Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-funding-request-detail-report",
        },
        {
          menuTitle: "School Funding Request Summary Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-funding-request-summary-report",
        },
        {
          menuTitle: "School Officers Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-officers-report",
        },
        {
          menuTitle: "PDF Test",
          icon: "fa-light fa-file-pdf",
          menuLink: "/report/pdf",
        },
      ],
    });
  }
  if (userCategory === "UC_S") {
    menuItems.push({
      menuTitle: "Reports",
      icon: "fa-light fa-file-chart-column",
      subMenus: [
        {
          menuTitle: "Donation Transactions Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/donation-transactions",
        },
        {
          menuTitle: "Participating Schools Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/participating-schools-report",
        },
        {
          menuTitle: "School Donors Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-donors-report",
        },
        {
          menuTitle: "School Funding Request Detail Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-funding-request-detail-report",
        },
        {
          menuTitle: "School Funding Request Summary Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-funding-request-summary-report",
        },
        {
          menuTitle: "School Officers Report",
          icon: "fa-light fa-file-invoice",
          menuLink: "/report/school-officers-report",
        },
      ],
    });
  }
  if (myProfileOptions.subMenus?.length && myProfileOptions.subMenus.length > 0)
    menuItems.push(myProfileOptions);

  return menuItems;
};

function getLink(
  userCategory: UserCategoryEnum,
  userRole: UserRole,
  userReference: string,
) {
  switch (userCategory) {
    case UserCategoryEnum.UC_A:
      return `/administrator/update/${userReference}`;
    case UserCategoryEnum.UC_S:
      return `/schoolOfficer/update?sor=${userReference}`;
    case UserCategoryEnum.UC_D:
      switch (userRole.trim()) {
        case DonorRoleEnum.DT_P:
          return `/donor/update/privatedonor`;
        case DonorRoleEnum.DT_B:
          return `/donor/update/businessdonor`;
        default:
          return "#";
      }

    default:
      return "#";
  }
}
